export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_BASE = 'https://sellyourcar2jack.directaffinitycx.net/api/v1'
export const AUTH_API_KEY='f84fa777-35e5-4ceb-b18a-beae2f4e1df1'